import { FC, Fragment } from "react";
import ArrowDropUpOutlinedIcon from "@mui/icons-material/ArrowDropUpOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { GroupingByTagChip } from "./GroupingByTagChip";

export const GroupingByTagValuesTriggerEndAdornment: FC<{
  open: boolean;
}> = ({ open }) => {
  return (
    <Fragment>
      <GroupingByTagChip />
      {open ? (
        <ArrowDropUpOutlinedIcon color="action" />
      ) : (
        <ArrowDropDownOutlinedIcon color="action" />
      )}
    </Fragment>
  );
};
